module.exports = __webpack_public_path__ + "static/media/12.96471c0d.wav";